import * as z from 'zod';
import { VALIDATION_MESSAGES } from '@/features/forms/validation';
import { CONTACT_TYPES, SUBJECT_TYPES } from '@/features/forms/FormContato/data';

const validationScheme = z
  .object({
    contactType: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    companyName: z.string(), //.min(1, { message: VALIDATION_MESSAGES.required }),
    subject: z.string().min(1, { message: VALIDATION_MESSAGES.required }),

    // Subject=Travel
    origin: z.string(), //.min(1, { message: VALIDATION_MESSAGES.required }),
    destination: z.string(),
    dateDepart: z.string(),
    dateReturn: z.string(),
    paxNumber: z.string(),

    // Message
    message: z.string().min(1, { message: VALIDATION_MESSAGES.required }),

    // Contact
    name: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    email: z.string().email({ message: VALIDATION_MESSAGES.email }),
    phone: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    subscribeNews: z.boolean(),

    phoneData: z.object({
      number: z.string(),
      countryName: z.any(),
      iso2: z.any(),
      dialCode: z.any(),
    }),
  })
  .superRefine((val, ctx) => {
    if (val.contactType === CONTACT_TYPES.AGENCIA_DE_VIAGENS.value && !val.companyName) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: VALIDATION_MESSAGES.required,
        path: ['companyName'],
      });
    }
    if ([SUBJECT_TYPES.VIAGENS, SUBJECT_TYPES.PASSAGENS_AEREAS].includes(val.subject)) {
      if (!val.origin) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: VALIDATION_MESSAGES.required,
          path: ['origin'],
        });
      }
      if (!val.destination) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: VALIDATION_MESSAGES.required,
          path: ['destination'],
        });
      }
      if (!val.dateDepart) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: VALIDATION_MESSAGES.required,
          path: ['dateDepart'],
        });
      }
      if (!val.dateReturn) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: VALIDATION_MESSAGES.required,
          path: ['dateReturn'],
        });
      }
      if (!val.paxNumber) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: VALIDATION_MESSAGES.required,
          path: ['paxNumber'],
        });
      }
    }
  });

export type FormContactDataType = z.infer<typeof validationScheme>;
export default validationScheme;
